export default "__VITE_ASSET__42b59a73__"